export default __webpack_public_path__ + "b8ece26abaa438d8e19b60537bd777f4.png";